import React from 'react';
import { AmericanExpressLogo as BaseAmericanExpressLogo } from '@move-frontend/form';
import { useTranslationForType } from '../hooks/useTranslationForType';
import { CreditCardType } from '../../../domain/models';

export const AmericanExpressLogo = () => {
	const alt = useTranslationForType(CreditCardType.AmericanExpress);

	return <BaseAmericanExpressLogo alt={alt} />;
};
